import { Children } from 'react';

export const Condition = ({ children, statement, fallback }) => {
  return statement ? children : fallback;
};

export const Iteration = ({ render, items }) => Children.toArray(items?.map((item, index, array) => render(item, index, array)));

export const Element = ({ value }) => value;
